<template>
  <div class="w-100 d-lg-flex align-items-center justify-content-center">
    <b-img
      fluid
      :src="imgLogo"
      alt="logo"
    />
  </div>
</template>
<script>
import { 
  BImg, 
} from 'bootstrap-vue'
export default {
  components: {
    BImg,
  },
  data() {
    return {
      imgLogo: require('@/assets/images/logo/isologo.svg'),
    }
  },
}
</script>
